import { render, staticRenderFns } from "./VTableEditable.vue?vue&type=template&id=7996c47e&scoped=true&"
import script from "./VTableEditable.vue?vue&type=script&lang=js&"
export * from "./VTableEditable.vue?vue&type=script&lang=js&"
import style0 from "./VTableEditable.vue?vue&type=style&index=0&id=7996c47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996c47e",
  null
  
)

export default component.exports